import React from "react";
const Footer = () => (
  <footer className="footer">
    <p className="footer-text">Copyright 2020 Argent Bank</p>
  </footer>
);
export default Footer;
